import axios from "axios";

export class CapacityTableService {
    getCapacityTableData() {
        return axios.get('/appapv/getMinimumCapacityScreen.action', {})
            .then(res => res.data)
            .catch(error => undefined);
    }

    getBorrowerInstitutions(lenderId) {
        return axios.get('/appapv/getInstitutionCanOperateByLender.action', {})
            .then(res => res.data)
            .catch(error => undefined);
    }

    editMinimumCapacity(params) {
        return axios.post('/appapv/updateMinimumCapacity.action', {}, {
            params: {
                minimumCapacity: (params.minimumCapacity / 100),
                deleteExceptions: params.deleteExceptions,
            }})
            .then(res => res.data)
            .catch(error => undefined);
    }

    updateException(params){
        return axios.post('/appapv/updateMinimumCapacityPerInstitution.action', {}, {
            params: {
                borrowerId: params.borrowerId,
                minimumCapacity: (params.minimumCapacity / 100),
            }})
            .then(res => res.data)
            .catch(error => undefined);
    }

    deleteException(borrowerId){
        return axios.post('/appapv/deleteMinimumCapacityPerInstitution.action', {}, {
            params: {
                borrowerId: borrowerId,
            }})
            .then(res => res.data)
            .catch(error => undefined);
    }
}